import { Link } from "react-router-dom";
import { Heart, PlayCircle, Star } from "lucide-react";
import { InfoPage } from "@/components/InfoPage";
import { useLang } from "@/lib/i18n";

const SECTIONS = [
  ["Who built it", ["Hi, I'm Terry. I've been fuel hauling for 5 years.",
    "I built Fuel Hauler Pro for the tools I wanted at the fill box: a quick stick check, a drop that won't overfill, and answers when the store's chart is missing or the console doesn't add up."]],
  ["Why it's free", "Every feature is free for every driver. Donations and a few ads pay for the servers and the photo reader."],
  ["What it's not", "It gives estimates from standard tank shapes and photos. The store's certified chart, the console and your own stick always come first."],
  ["Get in touch", "Found a wrong number, want a feature, or run a fleet that wants to use it? Email {email} or use Ask for help in the app."],
];

export default function AboutPage() {
  const { t, lang } = useLang();
  return (
    <InfoPage testid="about-screen" title="About Fuel Hauler Pro" sections={SECTIONS}>
      <div className="about-links">
        <a className="ghost-btn" href={lang === "es" ? "/tutorial-es.mp4" : "/tutorial-en.mp4"} target="_blank" rel="noreferrer" data-testid="about-video"><PlayCircle size={16} />{t("How-to video")}</a>
        <Link className="ghost-btn" to="/reviews" data-testid="about-reviews"><Star size={16} />{t("Driver reviews")}</Link>
        <Link className="ghost-btn" to="/guide" data-testid="about-guide">{t("How-to guide")}</Link>
        <Link className="ghost-btn" to="/faq" data-testid="about-faq">{t("FAQ")}</Link>
        <Link className="ghost-btn" to="/donate" data-testid="about-donate"><Heart size={16} />{t("Donate")}</Link>
      </div>
      <div className="about-legal"><Link to="/privacy" data-testid="about-privacy">{t("Privacy policy")}</Link> · <Link to="/terms" data-testid="about-terms">{t("Disclaimer & Terms")}</Link></div>
    </InfoPage>
  );
}
